import './App.css';
import PlutoPeakDetector from './PlutoDetector';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>PlutoSDR Signal Detector</h1>
        <p>Connects to Maia SDR, finds peaks, and makes sound.</p>
        <PlutoPeakDetector />
      </header>
    </div>
  );
}

export default App;
